import axiosHandler from "../utils/axiosHandler.ts";

const UM_SERVICE = process.env.REACT_APP_USERMGMT_SVC_URL;

const authApi = async () => {
  const response = await axiosHandler.get(UM_SERVICE + "login");
  return response.data;
};

export { authApi };
